import {
  ONE_STAR_RATING,
  TWO_STAR_RATING,
  THREE_STAR_RATING,
  FOUR_STAR_RATING,
  FIVE_STAR_RATING,
} from '../../constants/ratings';

export function getStarColor(rating) {
  const colors = {
    [ONE_STAR_RATING]: 'red',
    [TWO_STAR_RATING]: 'orange',
    [THREE_STAR_RATING]: 'yellow',
    [FOUR_STAR_RATING]: 'olive',
    [FIVE_STAR_RATING]: 'green',
  };

  return colors[rating] || 'grey';
}

export function getStarName(rating) {
  const names = {
    [ONE_STAR_RATING]: '1',
    [TWO_STAR_RATING]: '2',
    [THREE_STAR_RATING]: '3',
    [FOUR_STAR_RATING]: '4',
    [FIVE_STAR_RATING]: '5',
  };
  return `${names[rating]} Star`;
}
